function quickShopModalFunction() {
  let btns = [];
  const closeBtns = document.querySelectorAll('.quickshop .close__btn');
  const modals = document.querySelectorAll('.quickshop.modal');

  btns = document.querySelectorAll('.quick__shop-btn');

  btns.forEach(btn => {
    btn.addEventListener("click", (e) => {
      const prodId = e.target.dataset.id;
      const modal = document.querySelector(`.modal.quickshop[data-prodid="${prodId}"]`);

      const overlay = document.createElement('div');
      overlay.classList.add('overlay');

      overlay.addEventListener("click", () => {
        document.documentElement.style.overflowY = "unset";
        document.querySelector(`.modal.quickshop[data-prodid="${prodId}"]`).classList.add('hidden');
        document.querySelectorAll('.overlay').forEach((overlay) => overlay.remove());
      });
      
      document.body.appendChild(overlay);
      document.documentElement.style.overflowY = "hidden";
      modal.classList.remove('hidden');

      modal.querySelectorAll('input[type="radio"][checked]').forEach((radio) => {
        radio.nextElementSibling.click();
      });
    });
  });

  closeBtns.forEach(btn => {
    btn.addEventListener("click", (e) => {
      e.target.closest('.quickshop').classList.add('hidden');
      document.querySelector('.overlay').remove();
      document.documentElement.style.overflowY = "unset";
    });
  });

  modals.forEach(modal => {
    const submit = modal.querySelector('.product-form__buttons button');

    submit.addEventListener('click', (e) => {
      const error = document.querySelector('.quickshop:not(.hidden) .product-form__error-message-wrapper');
      const errorMessage = document.querySelector('.quickshop:not(.hidden) .product-form__error-message');
      const prod = modal.querySelector('.product__title').dataset.handle.toLowerCase().split(" ").join('-');
      const checkedOption = modal.querySelector('.quickshop.modal .product-form__input input:checked');
      const cartNotification = document.querySelector('cart-notification');

      // Fetch product data
      fetch(`/products/${prod}.js`)
        .then(response => response.json())
        .then(product => {
          const prodVariants = product.variants;

          // Fetch cart data
          return fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
              let quantity = modal.querySelector('.quantity__input').value;
              quantity = parseInt(quantity);
              const old_qty = cart.item_count;
              const totals = quantity + old_qty;
              let variantId = '';
              let availability = false;

              prodVariants.forEach(variant => {
                if (checkedOption) {
                  if (variant.title === checkedOption.value) {
                    variantId = variant.id;
                    availability = variant.available;
                  }
                } else {
                  variantId = product.variants[0].id;
                  availability = product.variants[0].available;
                }
              });

              if (availability) {
                error.classList.add('hidden');
                
                let item;
                if (document.querySelector('.rc_widget__option--active .rc_widget__option__input')) {
                  item = document.querySelector('.rc_widget__option--active .rc_widget__option__input').id;
                } else {
                  item = 'single';
                }

                if (item.indexOf('subsave') >= 0) {
                  const sellingPlan = product.selling_plan_groups[0].selling_plans[0].id;
                  
                  fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ 
                      items: [{
                        id: variantId,
                        quantity: quantity,
                        selling_plan: sellingPlan
                      }]
                    })
                  })
                    .then(response => {
                      e.target.closest('.quickshop').classList.add('hidden');
                      document.documentElement.style.overflowY = "unset";
                      document.querySelector('.overlay').remove();
                      if (cartNotification) {
                        cartNotification.productJustAddedToCartByQuickAdd();
                      }
                      return response.json();
                    })
                    .catch((error) => {
                      console.error('Error:', error);
                      e.preventDefault();
                    });
                } else {
                  fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ 
                      items: [{ 
                        id: variantId, 
                        quantity: quantity 
                      }]
                    })
                  })
                    .then(response => {
                      e.target.closest('.quickshop').classList.add('hidden');
                      document.documentElement.style.overflowY = "unset";
                      document.querySelector('.overlay').remove();
                      if (cartNotification) {
                        cartNotification.productJustAddedToCartByQuickAdd();
                      }
                      return response.json();
                    })
                    .then(response => {
                      if (old_qty <= 0) {
                        document.getElementById('cart-icon-bubble').innerHTML += '<div class="cart-count-bubble"><span aria-hidden="true" class="cart_qty_value">' + totals + '</span></div>';
                      } else {
                        document.getElementsByClassName('cart_qty_value')[0].innerText = totals;
                      }
                    })
                    .catch((error) => {
                      console.error('Error:', error);
                      e.preventDefault();
                    });
                }
              } else {
                error.classList.remove('hidden');
                errorMessage.innerText = 'The product is sold out';
              }
            });
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
          e.preventDefault();
        });
    });
  });
}

function blurBadges() {
  const buttons = document.querySelectorAll('.quick__shop-btn');
  buttons.forEach(btn => {
    btn.addEventListener('mouseenter', function () {
      const badge = this.parentElement.querySelector('.knesko-card__badge');
      if (badge) badge.classList.add('blur');
    });
    btn.addEventListener('mouseleave', function () {
      const badge = this.parentElement.querySelector('.knesko-card__badge');
      if (badge) badge.classList.remove('blur');
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  quickShopModalFunction();
  // blurBadges();
});